import React from 'react';
import css from './css.less';
const Sider = (props) => {
  const { height } = props;
  return (
    <div style={{ height }} className={css.siderContainer}>
      Horizental Sider
    </div>
  );
};
export default Sider;
